import FootTrafficFilterApi from '@/Enums/Attribution/FootTraffic/FilterApi.enum';
import { Role } from '@/Enums/Users/Role.enum';
import {
  IAttributionFootTrafficApiFilters,
  IBeeswaxAttributionApiFilters,
  IFootTrafficCampaignApiFilter,
  IFootTrafficLineItemApiFilter,
} from '@/Interfaces/Attribution/ApiFilters.interface';
import {
  IClientControlOption,
  IGroupedControlOption,
  IWhitelabelFilterOption,
} from '@/Interfaces/ControlOption.interface';
import { getAdvertiserCampaignFilters, getControlOptionsValues } from '@/helpers/filters/filterMapping';
import { FootTrafficFilters, WebVisitsFilters } from '@/types/Attribution/filters.types';

export const getBeeswaxAttributionFilter = (
  filters: WebVisitsFilters,
  role: Role,
  clients: IClientControlOption[],
  whitelabels: IWhitelabelFilterOption[],
): IBeeswaxAttributionApiFilters => {
  const res = getAdvertiserCampaignFilters(filters, role, clients, whitelabels, 'value');

  const { advertiserIds, campaignIds } = res;
  return {
    dateRangeStart: filters.dateRangeStart,
    dateRangeEnd: filters.dateRangeEnd,
    advertiserIds,
    campaignIds,
    lineItemIds: getControlOptionsValues(filters.placement),
    eventIds: getControlOptionsValues(filters.events),
  };
};

export const groupIdFilter = <T extends Partial<Record<FootTrafficFilterApi, unknown[]>>>(
  entities: IGroupedControlOption[] | undefined,
): T | undefined => {
  if (!entities?.length) {
    return undefined;
  }
  return entities.reduce((acc, cur) => {
    const api = cur.groupValue! as FootTrafficFilterApi;
    acc[api] = [...(acc[api] ?? []), cur.value];
    return acc;
  }, {} as T);
};

export const getFootTrafficReportFilter = (
  filters: FootTrafficFilters,
  role: Role,
  clients: IClientControlOption[],
  whitelabels: IWhitelabelFilterOption[],
): IAttributionFootTrafficApiFilters => {
  const passedFilters = { ...filters, campaigns: [] };
  const resultFilters = getAdvertiserCampaignFilters(passedFilters, role, clients, whitelabels, 'value');

  const { advertiserIds } = resultFilters;
  const campaignIds = groupIdFilter<IFootTrafficCampaignApiFilter>(filters.campaigns);
  const lineItemIds = groupIdFilter<IFootTrafficLineItemApiFilter>(filters.lineItems);
  const locationIds = getControlOptionsValues(filters.locations ?? []);
  const apiFilter: IAttributionFootTrafficApiFilters = {
    dateRangeStart: filters.dateRangeStart,
    dateRangeEnd: filters.dateRangeEnd,
    advertiserIds,
    locationIds,
  };

  if (lineItemIds) {
    return { ...apiFilter, lineItemIds };
  }
  if (campaignIds) {
    return { ...apiFilter, campaignIds };
  }
  return apiFilter;
};
